export default __webpack_public_path__ + "static/media/AuthCard.59d712d6.png";